import Fontfaceobserver from 'fontfaceobserver';

var loadFont = function (font, timeout) {
  if (timeout === void 0) {
    timeout = 30000;
  }

  return new Promise(function (resolve, reject) {
    var _font = new Fontfaceobserver(font);

    _font.load(null, timeout).then(function () {
      return resolve(font);
    }, reject);
  });
};

export default loadFont;
